<div class="tabs" [class.tabs--full-width]="fullWidth()" [class.tabs--centered]="centered()">
  @for (tab of tabs(); track tab.key) {
    <div class="tabs__item" [class.tabs__item--active]="activeTab() === tab.key">
      <button class="tabs__btn" (click)="onTabChange(tab.key)">
        {{ tab.label | translate }}
      </button>
      <div class="tabs__underline"></div>
    </div>
  }
</div>
